import LoadState from '@/common/load-state';
import {useAuthState, useLoadUserInfo} from '@/store/auth-slice';
import {useGlobalAction} from '@/store/global-slice';
import AuthUtil from '@/util/auth-util';
import React, {useEffect} from 'react';
import UserLoad from '@/component/user-load';

const UserAuth = () => {
    const {loadUserInfoWithTicket} = useLoadUserInfo();
    const {userLoadState, user} = useAuthState();
    const {reload} = useGlobalAction();

    useEffect(() => {
        const load = () => {
            let search = window.location.search || '';
            const index = search.indexOf('?');
            if (index >= 0) {
                search = search.substring(index + 1);
            }
            const array = search.split('&');
            const param: {[key: string]: string} = {};
            for (const item of array) {
                const split = item.split('=');
                if (split && split.length > 1 && split[0]) {
                    param[split[0]] = split[1];
                }
            }
            loadUserInfoWithTicket(param.ticket || '');
        };

        if (userLoadState === LoadState.INIT) {
            load();
        }
    }, [userLoadState, loadUserInfoWithTicket]);

    useEffect(() => {
        if (userLoadState === LoadState.LOADED) {
            let url = '';
            if (user) {
                url = AuthUtil.getReturnUrl() || '/';
                AuthUtil.setReturnUrl('');
            } else {
                url = '/login';
            }
            window.history.replaceState(undefined, '', url);

            reload();
        }
    }, [reload, userLoadState, user]);

    return <UserLoad />;
};

export default UserAuth;
